<template>
  <div class="main-layout" :class="{'has-header': $props.hasHeader}">
    <div class="header-container" v-if="hasHeader">
      <top-header :main-menu="$props.mainMenu" v-if="userAuthorized"/>
    </div>
    <template v-if="pageReady">
      <div class="content" v-if="userAuthorized">
        <slot></slot>
      </div>
      <flash-message :position="'right bottom'"></flash-message>
      <terms-of-use-check @terms-ok="handleTermsConfirmation"/>
      <security-code-check @security-code-ok="handleSecurityCodeEvent"/>
      <notification-list v-if="$props.loggedIn === 'True' && !isPublicRoute"/>
    </template>
    <base-full-loader/>
  </div>
</template>

<script>
import TopHeader from '@/components/common/navigation/top-header'
import TermsOfUseCheck from '@/components/common/terms-of-use-check'
import { customRouter } from '@/customRouter'
import { getUserToken } from '@/services/tokenService'
import auth from '@/mixins/logout'
import SecurityCodeCheck from '@/components/common/security-code-check'
import NotificationList from '@/components/notifications/notification-list'

export default {
  name: 'main-layout',
  data () {
    return {
      pageReady: false,
      termsOk: false,
      securityCodeOk: false
    }
  },
  components: { NotificationList, SecurityCodeCheck, TermsOfUseCheck, TopHeader },
  computed: {
    userAuthorized () {
      return this.termsOk && this.securityCodeOk
    },
    isPublicRoute () {
      return customRouter.isPublicRoute()
    }
  },
  mixins: [auth],
  props: {
    mainMenu: String,
    hasHeader: {
      type: Boolean,
      default: true
    },
    loggedIn: {
      type: String,
      default: ''
    }
  },
  methods: {
    /**
     * Pošto ne možemo biti sigurni da li će token stići pre nego što neka od komponenti pozove bilo koji servis
     * koji zahteva autorizaciju, ovde čekamo da dobijemo token, nakon čega se renderuje ostatak stranice ispod headera preko v-if direktive
     * što će okinuti mount hook za bilo koju komponentu koja se nalazi u default slotu.
     * Ako se čeka duže od 2 sekunde, pokazujemo full screen loader, da ne pomisli korisnik da se nešto zaglavilo ili da ne radi
     * @param count - Broj pokusaja pre nego sto odustanemo od cekanja tokena
     */
    checkIfTokenAvailable (count = 0) {
      const tempTimeout = setTimeout(() => {
        if (getUserToken()) {
          clearTimeout(tempTimeout)
          this.pageReady = true
          this.$loader.hide()
        } else if (count === 7) {
          this.$loader.show()
          this.checkIfTokenAvailable(count + 1)
        } else if (count > 50) {
          // try for 15s, if it's not working logout user
          clearTimeout(tempTimeout)
          this.logoutUser()
        } else {
          this.checkIfTokenAvailable(count + 1)
        }
      }, 300)
    },
    handleTermsConfirmation () {
      this.termsOk = true
    },
    handleSecurityCodeEvent (value) {
      this.securityCodeOk = value
    }
  },
  mounted () {
    this.flashMessage.setStrategy('multiple')
    if (!customRouter.isPublicRoute() && !getUserToken()) {
      this.checkIfTokenAvailable()
    } else {
      this.pageReady = true
    }

    window.addEventListener('beforeunload', () => this.$loader.show(), { once: true })
  }
}
</script>

<style scoped lang="scss">
.main-layout {
  min-height: 100vh;

  .header-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: auto;
    z-index: map_get($z-index, header);
  }

  // IE fix for login page
  .content {
    display: flex;
    flex-direction: column;
  }

  &.has-header .content {
    padding-top: 54px;
    display: block;

    @media (map_get($breakpoints, sm)) {
      padding-top: 60px;
    }

    @media (map_get($breakpoints, lg)) {
      padding-top: 68px;
    }

    @media (map_get($breakpoints, xxl)) {
      padding-top: 88px;
    }
  }
}
</style>
